import * as React from 'react';

const MailIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 26 26" fill="none" {...props}>
    <rect
      x="3.25"
      y="5.4165"
      width="19.5"
      height="15.1667"
      rx="3"
      stroke="#ADB4C0"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.125 7.0415L13 15.1665L7.04169 9.20817"
      stroke="#ADB4C0"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MailIcon;
